/* WidthPro — conversion helpers: announcement rotator, delivery estimate,
   bundle/quantity picker, email-capture popup. */
(function () {
  var money = function (c) { return '$' + (c / 100).toFixed(2); };

  /* Announcement bar rotator */
  document.querySelectorAll('[data-annc]').forEach(function (bar) {
    var items = bar.querySelectorAll('.annc__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* Delivery estimate */
  var est = document.querySelector('[data-ship-est]');
  if (est) {
    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var a = new Date(); a.setDate(a.getDate() + 10);
    var b = new Date(); b.setDate(b.getDate() + 21);
    est.textContent = 'Estimated delivery ' + fmt(a) + ' – ' + fmt(b);
  }

  /* Bundle / quantity picker */
  document.querySelectorAll('[data-bundle]').forEach(function (bundle) {
    var form = bundle.closest('form');
    var qtyInput = form ? form.querySelector('[data-qty-input]') : null;
    var addBtn = form ? form.querySelector('[data-add-to-cart]') : null;
    var priceEl = document.querySelector('[data-price]');
    var unit = parseInt((priceEl && priceEl.textContent.replace(/[^0-9]/g, '')) || '0', 10); // dollars.cents -> digits
    // derive unit cents from the 1x option price text
    var oneNow = bundle.querySelector('[data-qty="1"] .now');
    var unitCents = oneNow ? Math.round(parseFloat(oneNow.textContent.replace(/[^0-9.]/g, '')) * 100) : 6999;
    bundle.querySelectorAll('[data-bundle-opt]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        bundle.querySelectorAll('[data-bundle-opt]').forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        var q = parseInt(opt.dataset.qty, 10);
        if (qtyInput) qtyInput.value = q;
        var total = q >= 2 ? Math.round(unitCents * q * 0.85) : unitCents * q;
        if (addBtn) {
          var lbl = addBtn.querySelector('[data-add-to-cart-label]') || addBtn;
          lbl.textContent = 'Add to cart — ' + money(total);
        }
      });
    });
  });

  /* Email capture popup */
  var pop = document.querySelector('[data-epopup]');
  if (pop) {
    var KEY = 'wp_epopup_seen';
    var seen = false;
    try { seen = localStorage.getItem(KEY) === '1'; } catch (e) {}
    function markSeen() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }
    function openPop() {
      if (seen || pop.classList.contains('is-open')) return;
      pop.classList.add('is-open'); markSeen(); seen = true;
    }
    function closePop() { pop.classList.remove('is-open'); }
    // delayed trigger
    if (!seen) setTimeout(openPop, 18000);
    // exit intent (desktop)
    document.addEventListener('mouseout', function (e) {
      if (!seen && e.clientY <= 0) openPop();
    });
    pop.querySelectorAll('[data-epopup-close]').forEach(function (b) { b.addEventListener('click', closePop); });
    pop.addEventListener('click', function (e) { if (e.target === pop) closePop(); });
    var form = pop.querySelector('[data-epopup-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.querySelector('input[name="email"]').value.trim();
        if (!/.+@.+\..+/.test(email)) { form.querySelector('input').focus(); return; }
        // capture into Shopify customers (marketing consent)
        var body = new URLSearchParams();
        body.append('form_type', 'customer');
        body.append('utf8', '✓');
        body.append('contact[email]', email);
        body.append('contact[accepts_marketing]', 'true');
        fetch('/contact', { method: 'POST', body: body }).catch(function () {});
        pop.classList.add('is-success');
      });
    }
  }
})();
